export class SmartphotoAdditionals {
    emails;
    notes;
    constructor(smartphoto) {
        this.emails = smartphoto.additionals?.emails ?? [];
        this.notes = smartphoto.additionals?.notes;
    }
}
